<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';

import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

const colorList = ['#e60049', '#0bb4ff', '#50e991', '#e6d800', '#9b19f5', '#ffa300', '#dc0ab4', '#b3d4ff', '#00bfa0'];

export default {
  name: 'MonthlyChart',
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({
        height: `400px`,
        position: 'relative',
      }),
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    monthNameList: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    visibleDataList: {
      type: Array,
      default: () => [],
    },
    isYearChart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartData: {
        labels: this.monthNameList,
        datasets: this.visibleDataList.map(({ label, key }, index) => {
          const color = colorList[index] || `#${Math.floor(Math.random() * 16777215).toString(16)}`;
          return {
            label,
            backgroundColor: color,
            borderColor: color,
            data: this.isYearChart ? this.data[key] : this.monthNameList.map((_, month) => this.data[month + 1][key]),
          };
        }),
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
          },
        },
      },
    };
  },
};
</script>
